import type { Artifact } from '@alatzidis/core'

export const GAMES_ARTIFACTS: Artifact[] = [
  {
    number: 'g·01',
    title: "Conway's Game of Life",
    blurb:
      'The classic, with its rules laid out and open to change: pick which neighbour counts give birth and which let a cell survive, or try HighLife, Seeds, Day & Night and the other famous variants.',
    href: '/games/conway-life',
  },
  {
    number: 'g·02',
    title: 'Schoolekantera',
    blurb:
      'Slither-style worm arena against two dozen bots. Eat food, grow longer, dodge their bodies and try to make them crash into yours. The whole simulation runs in a worker in your tab.',
    href: '/games/schoolekantera',
  },
  {
    number: 'g·03',
    title: 'The Chaos Game',
    blurb:
      'Pick targets, a jump ratio and a rule about which target may come next, then set a point loose. Sierpinski’s triangle is the famous case; carpets, flakes and spirals are a few settings away.',
    href: '/games/chaos',
  },
  {
    number: 'g·04',
    title: 'Cellular Wolfram',
    blurb:
      'Two hundred and fifty-six rules, each one deterministic. Some chaotic, some periodic, one Turing-complete. A 1D automaton playground.',
    href: '/games/wolfram',
  },
  {
    number: 'g·05',
    title: 'Strange Solids',
    blurb:
      'A WebGL2 raymarcher with four pre-baked SDFs — Mandelbulb, Mandelbox, Menger sponge, Sierpinski tetrahedron. Drag to orbit, scroll to zoom, watch the geometry breathe.',
    href: '/games/strange-solids',
  },
  {
    number: 'g·06',
    title: 'Mandelbrot, all the way down',
    blurb:
      'An explorer that keeps its focus to a zoom of 10²⁹⁰: arbitrary precision for one point per view, perturbation for every pixel, all of it in workers. Scroll anywhere and keep going.',
    href: '/games/mandelbrot',
  },
]
